import {Component, OnDestroy, OnInit} from '@angular/core';
import {AlertService} from '../../services/notify/alert.service';
import {AlertModel} from './alert.model';
import {animate, query, stagger, style, transition, trigger} from '@angular/animations';
import {SubscriptionLike} from 'rxjs';

export const listAnimation = trigger('listAnimation', [
    transition('* <=> *', [
        query(':enter',
            [
                style({opacity: 0, transform: 'translateX(-110%)'})
                , stagger('30ms', animate('300ms ease-in', style({opacity: 1, transform: 'translateX(0)'})))],
            {optional: true}
        ),
        query(':leave',
            animate('200ms', style({opacity: 0, transform: 'translateX(-110%)'})),
            {optional: true}
        )
    ])
]);

@Component({
    selector: 'app-component-alert',
    templateUrl: './alert.component.html',
    styleUrls: ['./alert.component.scss'],
    animations: [listAnimation]
})
export class AlertComponent implements OnInit, OnDestroy {

    public alerts: AlertModel[] = [];
    private subscription: SubscriptionLike;

    constructor(
        private alertService: AlertService
    ) {
    }

    ngOnInit(): void {
        this.subscription = this.alertService.ObservableData.subscribe(data => {
            this.alerts = data;
        });
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    deleteAlert(index): void {
        this.alertService.deleteAlert(index);
    }
}
